import HeroBg from "public/cloudMigration/AWS_ AzureToMOST.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Start Migration",
    link: "contact-us",
  },
  desc: "Shift your workloads from AWS, Azure, or GCP to OneMind MOST — an enterprise-grade OpenStack environment with full-stack transparency, robust DevOps integrations, and zero proprietary lock-in. ",
  title: "Unlock Cost Control. Regain Cloud Independence",
  image: HeroBg,
};
